import { Colors } from '@src/colors';
import styled from 'styled-components';
import CheckboxCheckedIcon from '../../assets/checkbox-checked.svg';
import { Input } from './Input.styled';

export const CheckboxInput = styled(Input).attrs({
    type: 'checkbox',
})`
    height: 24px;
    width: 24px;
    border-radius: 4px;
    cursor: pointer;
    background: ${Colors.midnight2};
    border: 1px solid ${Colors.midnight30};
    color: ${Colors.midnight30};
    appearance: none;

    &:checked {
        border: 1px solid ${Colors.midnight30};
        background: ${Colors.midnight80} url(${CheckboxCheckedIcon}) no-repeat 1px 0;
    }

    &:disabled {
        cursor: default;
        background: ${Colors.grayEight};
        border: 1px solid ${Colors.midnight70};

        &:checked {
            background: ${Colors.midnight70} url(${CheckboxCheckedIcon}) no-repeat 1px 0;
        }
    }
`;
